/* eslint-disable import/prefer-default-export */
import { createUrl } from '_clean-code/utils/urlHelper';
import apiClient from '../../api/index';
import {
  IShiftSettingsService,
  GetShiftSettingsResponse
} from './contracts/shiftSettings.service';
import { Logger } from '_clean-code/utils/logger';

export const ShiftSettingsService: IShiftSettingsService = {
  async getShiftSettings(
    from: Date,
    to: Date,
    machineIds: number[],
    fetchTime?: number,
    isHistorical?: boolean
  ): Promise<{
    data: GetShiftSettingsResponse[];
    fetchTime?: number;
  }> {
    try {
      const response = (await apiClient.request(
        'GET',
        createUrl(`/shifts${isHistorical ? '/historical' : ''}`)
          .addQueryParam('start', from.toISOString())
          .addQueryParam('end', to.toISOString())
          .addQueryParamMany('machineId', machineIds)
          .toStringUrl()
      )) as GetShiftSettingsResponse[];

      const data =
        response.map((x) => ({
          ...x,
          start: new Date(x.start),
          end: new Date(x.end)
        })) || [];

      return {
        data,
        fetchTime
      };
    } catch (error) {
      Logger.error('ShiftSettingsService::getShiftSettings', error);
      return {
        data: [],
        fetchTime
      };
    }
  },
  async removeShifts(
    from: Date,
    to: Date,
    machineIds: number[],
    shiftNames?: string[],
    weekdays?: number[]
  ): Promise<void> {
    await apiClient.request('DELETE', createUrl('/shifts').toStringUrl(), {
      machineIds,
      start: from,
      end: to,
      titles: shiftNames,
      weekdays
    });
  },
  async createShifts(
    start: Date,
    end: Date,
    durationInSeconds: number,
    timezone: string,
    weekdays: string[],
    machineIds: number[],
    shiftName: string,
    operatorId: number | null,
    targetQuantity: number | undefined
  ): Promise<void> {
    try {
      await apiClient.request('POST', createUrl('/shifts').toStringUrl(), {
        machineIds,
        start,
        end,
        title: shiftName,
        weekdays,
        timezone,
        durationInSeconds,
        operatorId,
        targetQuantity
      });
    } catch (error) {
      Logger.error('ShiftSettingsService::createShifts', error);
      throw (error as any).response.data;
    }
  },
  async updateShift(
    shiftId: number,
    start: Date,
    end: Date,
    shiftName: string,
    operatorId: number | null,
    targetQuantity: number | undefined,
    nominalSpeed: number | undefined | null
  ): Promise<void> {
    try {
      await apiClient.request(
        'PATCH',
        createUrl(`/shifts/${shiftId}`).toStringUrl(),
        {
          start,
          end,
          title: shiftName,
          operatorId,
          targetQuantity,
          nominalSpeed
        }
      );
    } catch (error) {
      Logger.error('ShiftSettingsService::updateShift', error);
      throw (error as any).response.data;
    }
  }
};
